// extracted by mini-css-extract-plugin
export default {"captionReviewModal":"captionReviewModal__KOLa9D","divider":"divider__HOgfID","subHeader":"subHeader__TIga_6","buttons":"buttons__HSwxDd"};